import { Dispatch } from 'redux';

import { updateLoadingLogin, updateLoginError } from 'connect/actions';
import { RequestAppointment } from 'connect/saga/handlers/appointment/request-appointment';
import { RequestPatientPhoneVerification, VerifyPatientPhone } from 'connect/saga/handlers/patient/unverified-phone';
import { UpdatePatientDetails } from 'connect/saga/handlers/patient/update-details';
import { RequestEmailVerification, RequestPhoneVerification, RequestPhoneVerificationSmsStatus, VerifyEmail, VerifyPhone } from 'connect/saga/handlers/patient/verify';
import { Authenticate } from 'connect/saga/handlers/user/authenticate';

import { Signup } from 'connect/saga/handlers/user/signup';

export const resetCheckoutData = (dispatch: Dispatch) => {
  dispatch(updateLoadingLogin(false));
  dispatch(updateLoginError(null));

  dispatch(Authenticate.reset());
  dispatch(Signup.reset());

  dispatch(UpdatePatientDetails.reset());

  dispatch(RequestEmailVerification.reset());
  dispatch(VerifyEmail.reset());
  dispatch(RequestPhoneVerification.reset());
  dispatch(RequestPhoneVerificationSmsStatus.reset());
  dispatch(VerifyPhone.reset());
  dispatch(RequestPatientPhoneVerification.reset());
  dispatch(VerifyPatientPhone.reset());

  dispatch(RequestAppointment.reset());
};
